document.addEventListener('DOMContentLoaded', () => {
  const configEl = document.querySelector('#fp-options-config');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent.trim());
  } catch (e) {
    console.error('Invalid JSON in custom.options_config metafield:', e);
    return;
  }

  const root = document.querySelector('#fp-options-root');
  if (!root) return;

  const productForm = document.querySelector('product-form form');
  const currentPath = window.location.pathname.replace(/\/+$/, '');

  function setHiddenOption(index, label, value) {
    if (!productForm) return;

    const cleanLabel = (label || `Option ${index + 1}`).trim();
    const inputName = `properties[${cleanLabel}]`;

    let input = productForm.querySelector(`input[name="${inputName}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = inputName;
      productForm.appendChild(input);
    }
    input.value = value;
  }

  // A different garment needs a fresh size choice; never assume XL or carry a size across fits.
  async function navigateToProductType(targetUrl) {
    const url = new URL(targetUrl, window.location.origin);
    url.searchParams.delete('variant');
    window.location.href = url.href;
  }

  const wrapper = document.createElement('div');
  wrapper.className = 'fp-options-wrapper';

  (config.options || []).forEach((opt, index) => {
    const group = document.createElement('div');
    group.className = 'fp-option-group';

    const labelEl = document.createElement('div');
    labelEl.className = 'fp-option-label';
    labelEl.textContent = opt.label === 'Type' ? 'This artwork, your way' : opt.label || `Option ${index + 1}`;
    group.appendChild(labelEl);

    // RADIO OPTIONS WITH ICONS
    if (opt.type === 'radio') {
      const choiceRow = document.createElement('div');
      choiceRow.className = 'fp-option-row';
      group.appendChild(choiceRow);
      (opt.values || []).forEach(rawValue => {
        const valueObj =
          typeof rawValue === 'string' ? { label: rawValue } : rawValue || {};

        const labelText = valueObj.label || '';
        const targetUrl = valueObj.url || null;
        const variantId = valueObj.variant_id || null;
        const iconUrl = valueObj.icon || null;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fp-option-btn';
        btn.setAttribute('aria-pressed','false');
        if (targetUrl) {
          try { btn.dataset.fpTargetPath = new URL(targetUrl,window.location.origin).pathname; } catch { /* Keep existing option fallback. */ }
        }

        if (iconUrl) {
          const tile = document.createElement('div');
          tile.className = 'fp-option-tile';
          const iconWrap = document.createElement('div');
          iconWrap.className = 'fp-option-icon-wrap';
          const img = document.createElement('img');
          img.src = iconUrl;
          img.alt = '';
          img.width = 36;
          img.height = 36;
          img.loading = 'lazy';
          img.className = 'fp-option-icon';
          iconWrap.appendChild(img);
          const label = document.createElement('div');
          label.className = 'fp-option-text';
          label.textContent = labelText;
          tile.append(iconWrap,label);
          btn.appendChild(tile);
        } else {
          btn.textContent = labelText;
        }

        btn.addEventListener('click', async () => {
          group.querySelectorAll('.fp-option-btn').forEach(s => {
            s.classList.remove('active');
            s.setAttribute('aria-pressed','false');
          });
          btn.classList.add('active');
          btn.setAttribute('aria-pressed','true');

          setHiddenOption(index, opt.name || opt.label, labelText);

          if (targetUrl) {
            await navigateToProductType(targetUrl);
            return;
          }

          if (variantId && productForm) {
            const idInput = productForm.querySelector('input[name="id"]');
            if (idInput) {
              idInput.value = variantId;
            }
          }
        });

        // Auto-highlight if this button matches current URL
        if (targetUrl) {
          try {
            const urlObj = new URL(targetUrl, window.location.origin);
            const btnPath = urlObj.pathname.replace(/\/+$/, '');
            if (btnPath === currentPath) {
              btn.classList.add('active');
              btn.setAttribute('aria-pressed','true');
              setHiddenOption(index, opt.name || opt.label, labelText);
            }
          } catch (e) {
            console.warn('Invalid targetUrl in options_config:', targetUrl);
          }
        }

        choiceRow.appendChild(btn);
      });
    }

    // DROPDOWN (still supported if you ever need it)
    if (opt.type === 'dropdown') {
      const select = document.createElement('select');
      select.className = 'fp-option-select';

      (opt.values || []).forEach(rawValue => {
        const valueObj =
          typeof rawValue === 'string' ? { label: rawValue } : rawValue || {};
        const labelText = valueObj.label || '';

        const optionEl = document.createElement('option');
        optionEl.value = labelText;
        optionEl.textContent = labelText;
        select.appendChild(optionEl);
      });

      if (opt.values && opt.values.length > 0) {
        const first =
          typeof opt.values[0] === 'string'
            ? opt.values[0]
            : opt.values[0].label || '';
        setHiddenOption(index, opt.name || opt.label, first);
      }

      select.addEventListener('change', () => {
        setHiddenOption(index, opt.name || opt.label, select.value);
      });

      group.appendChild(select);
    }

    wrapper.appendChild(group);
  });

  root.appendChild(wrapper);
  window.FramePaceUX?.mountComparison(root,config);
});
